import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  CustomCollapseCard,
  CustomButton,
  CustomImage,
  CustomPagination,
  successDialog,
  Text,
} from '@src/components';

import { orderDelete, orderGetPageList, setSelectedOrder } from '@src/store/slice/orderSlice';
import { getOrderLimitDate, resetOrderLimits } from '@src/store/slice/orderLimitsSlice';
import { getCustomerVouList } from '@src/store/slice/customerSlice';

import reportsServices from '@src/services/reports.services';

import dayjs from '@src/utils/day';
import { defaultDateFormat } from '@src/utils/keys';
import { handleAuthStatus, moneyFormat, previewDownload } from '@src/utils/utils';

import { Collapse } from 'antd';
import { useMediaQuery } from '@src/hooks/useMediaQuery';
import iconDetail from '@src/assets/icons/detail-img.svg';
import iconNpInfo from '@src/assets/icons/icon-info.svg';
import iconDowndload from '@src/assets/icons/download-img.svg';
import iconPrinter from '@src/assets/icons/printer-img.svg';
import iconGiftDown from '@src/assets/icons/gift-icn-down.svg';
import iconGiftUp from '@src/assets/icons/gift-icn-up.svg';
import '@src/styles/myOrders/orderList.scss';
import DownloadModal from '@src/pages/ticketRestaurant/myOrders/DownloadModal';
import PaymentModal from '@src/pages/ticketRestaurant/myOrders/PaymentModal';
import OrderSummaryCardModal from '@src/pages/ticketRestaurant/myOrders/OrderSummaryCardModal';
import OrderSummaryBalanceModal from '@src/pages/ticketRestaurant/myOrders/OrderSummaryBalanceModal';
import OrderFilter from '@src/pages/ticketRestaurant/myOrders/OrderFilter';
import CustomPopover from '@src/components/CustomPopover';
import PropTypes from 'prop-types';
import { warningDialog } from '@src/components/CustomDialog';
import { VouIdCode } from '@src/store/enums';

const { Panel } = Collapse;

function getExpandIcon(setActiveCollapse, switchIcon, setActiveOrder, orderId, activeOrderId) {
  return ({ isActive }) => {
    setActiveCollapse(isActive);
    if (isActive) {
      setActiveOrder(orderId);
    } else if (activeOrderId && orderId === activeOrderId) {
      setActiveOrder(null);
    }
    return (
      <div style={{ borderRadius: '24px' }}>
        {isActive ? (
          <CustomImage className="open-close" src={!switchIcon ? iconGiftUp : iconGiftDown} />
        ) : (
          <CustomImage className="open-close" src={!switchIcon ? iconGiftDown : iconGiftUp} />
        )}
      </div>
    );
  };
}
getExpandIcon.propTypes = {
  setActiveCollapse: PropTypes.func,
  switchIcon: PropTypes.any,
  setActiveOrder: PropTypes.func,
  orderId: PropTypes.any,
  activeOrderId: PropTypes.any,
};

import SharedOrderList from '@src/pages/shared/OrderList';

const MarketOrderList = () => {
  const userAuthorizationMarketStatus = useSelector((state) => state?.user?.userAuthorizationMarketStatus);
  return <SharedOrderList vouId={VouIdCode.Market} isMarket={true} isCompliments={false} userAuthorizationStatus={userAuthorizationMarketStatus} />;
};

export default MarketOrderList;
